<template>
<Popover
    arrow
    :theme="theme"
    :visible="visible"
    @update:visible="handleVisibleChange"
    :trigger="trigger"
    :modifiers="modifiers"
    :popoverClass="[bem(), popoverClass]"
    :component="component"
    :placement="placement"
    :el="el"
    :appendToBody="appendToBody"
    :delayonMouseLeave="delayonMouseLeave"
>
    <slot />
    <template slot="content">
        <slot name="content">
            <Vnode :content="content" />
        </slot>
    </template>
</Popover>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bemMixin } from '../utils';
import Popover from '../popover';
import Vnode from '../v-node';
export default {
  name: 'g-tooltip',
  components: {
    Popover,
    Vnode
  },
  mixins: [bemMixin],
  props: {
    // 提示内容
    content: {
      type: [String, Object],
      default: ''
    },
    // 浮层最外层 class
    popoverClass: {
      type: [String, Array],
      default: ''
    },
    // popperJS options.modifiers
    modifiers: Object,
    // 是否可见
    visible: {
      type: Boolean,
      default: undefined
    },
    // 触发事件
    trigger: {
      type: String,
      default: 'hover',
      validator: function validator(value) {
        return ['click', 'hover', 'focus'].indexOf(value) > -1;
      }
    },
    // 主题色
    theme: {
      // 'dark' / ‘light’
      type: String,
      default: 'dark'
    },
    // 显示位置
    placement: {
      type: String,
      // 'top-start' 'top' 'top-end' 'left-start' 'left' 'left-end' 'bottom-start' 'bottom' 'bottom-end'
      default: 'bottom'
    },
    // 实际渲染组件
    component: {
      type: [String, Object],
      default: 'span'
    },
    el: String,
    // 是否插入到 document.body 节点中
    appendToBody: {
      type: Boolean,
      default: false
    },
    // 延迟多久消失
    delayonMouseLeave: {
      type: Number,
      default: 100
    }
  },
  methods: {
    handleVisibleChange(value) {
      this.$emit('update:visible', value);
    }

  }
};
</script>
<style>
.g-tooltip.g-tooltip {
  padding: 8px 16px;
  border-radius: 4px;
}

</style>
